import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import axiApi from "ApiCaller";
import TableAssetContainer from "./container/TableAssetContainerManager";
import ButtonsActions from "views/utils/buttonsActions";
import { useNavigate } from "react-router-dom";
import TopBarActions from "components/TopBarActions";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import { PagerModel } from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";
import ContainerFiltersManager from "./container/ContainerFiltersManager";
import OrderingModel from "components/ordering/OrderingModel";
import { useContext } from "react";
import AuthContext from "context/AuthContext";
import navsBridge from "./navsBridge";

const ViewContainers = () => {
    const { panel } = useContext(AuthContext);
    const { t: _Tr } = useTranslation("routes");
    const title = panel.panel_type == "w" ? _Tr("labels.containers") : _Tr("labels.bridges");
    const navigate = useNavigate();

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [itemsShown, setItemsShown] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [buttonsTB, setButtonsTB] = useState(new ButtonsActions());
    const bread = [
        {
            name: _Tr("labels.data-view"),
            url: "/data-view/",
            current: false,
        },
        { name: title, current: true },
    ];

    const [params, setParams] = useState({
        groups: [],
        groups_devices: [],
        islands: [],
        routes: [],
        zones: [],
    });

    useEffect(() => {
        const buttons = { ...buttonsTB };
        buttons.title = title;
        setButtonsTB(buttons);

        sessionStorage.removeItem("viewsDataContainersState");

        axiApi.get("/api/unloads/containers/filters/").then((resp) => {
            let params_ = { ...params };
            params_.groups = [...resp.data.groups];
            params_.groups_devices = [...resp.data.groups_devices];
            params_.islands = [...resp.data.islands];
            params_.routes = [...resp.data.routes];
            params_.zones = [...resp.data.zones];
            setParams(params_);
        });
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => fetchContainers();
        orderingRef.current.applyOrder = () => fetchContainers();

        const fetchGetContainers = async () => {
            setIsLoading(true);
            axiApi
                .get(`/api/assets/data/list/`)
                .then((resp) => {
                    items.current.all = [...resp.data.items];
                    items.current.showed = [...resp.data.items];
                    setItemsShown([...resp.data.items]);

                    if (resp.data && resp.data.pager) {
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                })
                .catch((error) => {
                    console.error("Error al enviar la solicitud:", error);
                })
                .finally(() => setIsLoading(false));
        };
        fetchGetContainers();
    }, []);

    function onClickRow(e) {
        let idx = parseInt(e.currentTarget.dataset.idx);
        let asset = items.current.showed[idx];

        if (e.target.tagName === "td" || e.target.tagName === "TD") {
            const aExist = e.target.querySelector("a");
            if (aExist) {
                navigate(`/data-view/data-container/unloads/${asset.uid}/`);
                return false;
            }
        }
        if (e.target.parentNode.tagName === "svg") {
            navigate(`/data-view/data-container/unloads/${asset.uid}/`);
            return false;
        }
        navigate(`/data-view/data-container/${asset.uid}/`);
    }

    filters.current.filter = () => fetchContainers();

    const fetchContainers = async () => {
        setIsLoading(true);
        axiApi
            .post(`/api/assets/data/list/`, filters.current.chosen, {
                params: { ...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams() },
            })
            .then((resp) => {
                items.current.all = [...resp.data.items];
                items.current.showed = [...resp.data.items];
                setItemsShown([...resp.data.items]);
                if (resp.data && resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
                sessionStorage.setItem(
                    "viewsDataContainersState",
                    JSON.stringify({
                        filters: filters.current.chosen,
                        ordering: orderingRef.current.getParams().o || "",
                    }),
                );
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <>
            {panel.panel_type === "w" ? (
                <NavBreadcrum navs={navs} bread={bread} />
            ) : (
                <NavBreadcrum navs={navsBridge} bread={bread} />
            )}
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <div>
                <ContainerFiltersManager
                    filters={filters}
                    params={params}
                    applyFilters={fetchContainers}
                    setItemsShown={setItemsShown}
                    isLoading={isLoading}
                    orderingRef={orderingRef}
                />
            </div>

            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" />
            <div className="row">
                <div className="col-12">
                    <div>
                        <div>
                            <div className="col-md col-12">
                                <LoaderSpinner isLoading={isLoading}>
                                    <TableAssetContainer
                                        itemsShown={itemsShown}
                                        onClickRow={onClickRow}
                                        orderingRef={orderingRef}
                                    />
                                </LoaderSpinner>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default ViewContainers;
